'use strict';

angular.module('cgmemApp')
  .factory('Member', ['$resource', function ($resource) {
		
		var parseMember = function(data) {
			try {
				var m = angular.fromJson(data);
			}
			catch(err) {
				return data;
			}
			if(m && m.dob && typeof m.dob == 'string')
				m.dob = new Date(m.dob);
			return m;
		}

		return $resource('/api/accounts/:accountId/members/:memberId', {accountId: '@accountId', memberId:'@_id'},	{
					'update': {
						method:'PUT',
						transformResponse: parseMember
					},
					'get': {
						transformResponse: parseMember
					},
					'save': {
						method:'POST',
						transformResponse: parseMember
					}
				});
  }]);
